import React from 'react';

export const ref_cartProducts: any = React.createRef();
